module.exports = __webpack_public_path__ + "static/media/support.c66a6f8c.svg";